export enum BOMType {
  OneK = '1K',
  Coinjection = 'Co-inj.',
  MultiK = 'Multi-K',
  Assembly = 'Assembly',
}
